var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconPencil(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M16.921 3.64a2.75 2.75 0 010 3.89l-8.485 8.485a.75.75 0 01-.383.205l-3.536.707a.75.75 0 01-.882-.883l.707-3.535a.75.75 0 01.205-.383l8.485-8.486a2.75 2.75 0 013.89 0zm-1.06 2.83A1.25 1.25 0 0014.092 4.7l-8.325 8.325-.442 2.21 2.21-.443L15.86 6.47z", clipRule: "evenodd" })));
}
export default IconPencil;
